import React from "react";
import { PortalTitle } from "../Portal";
import artsGowanusLogo from "../../assets/imgs/arts-gowanus-logo.png";
import artsGowanusLogoDark from "../../assets/imgs/arts-gowanus-logo-dark.png";
import brooklynFilmFestivalLogo from "../../assets/imgs/brooklyn-film-festival-logo.png";
import brooklynFilmFestivalLogoDark from "../../assets/imgs/brooklyn-film-festival-logo-dark.png";
import inycIphoneMockupDark from "../../assets/imgs/inyc-iphone16-mockup-dark.png";
import inycIphoneMockupLight from "../../assets/imgs/inyc-iphone16-mockup-light.png";
import redHookOpenStudiosLogo from "../../assets/imgs/red-hook-open-studios-logo.png";
import redHookOpenStudiosLogoDark from "../../assets/imgs/red-hook-open-studios-logo-dark.png";
import winterJazzfestLogo from "../../assets/imgs/winter-jazzfest-logo.png";

// every logo fits the same 2.85rem square, centered in the slot (logo files are trimmed to their artwork)
const festivalLogoSlotClassName =
  "ml-kit-4 flex h-[3.35rem] w-[4.6rem] shrink-0 items-center justify-center";

const Festivals = () => {
  return (
    <div className="min-h-[100vh] bg-[var(--inyc-primary)]">
      <PortalTitle>festivals</PortalTitle>
      <div className="px-kit-16 pt-kit-6 text-[var(--inyc-primary-text-color)]">
        <p className="mb-kit-20 text-kit-md font-['Primary-Bold'] leading-[1.35] text-[var(--inyc-primary-text-color)]">
          we offer interactive festival mapping.
          <br />
          anywhere in the world.
        </p>
        <div className="mb-kit-20 text-kit-base leading-[1.45] text-[var(--inyc-primary-text-color)]">
          <p className="text-kit-base font-['Primary-Medium']">selected clients:</p>
          <div className="mt-kit-8 space-y-[0.25rem]">
            <p className="flex items-center gap-kit-10">
              <a
                href="https://www.brooklynfilmfestival.org/"
                target="_blank"
                rel="noreferrer"
                className="inline-block w-[13rem] whitespace-nowrap underline"
              >
                Brooklyn Film Festival
              </a>
              <span className={festivalLogoSlotClassName}>
                <img
                  src={brooklynFilmFestivalLogo}
                  alt="Brooklyn Film Festival"
                  className="festival-client-logo-light max-h-[2.85rem] max-w-[2.85rem] object-contain"
                />
                <img
                  src={brooklynFilmFestivalLogoDark}
                  alt="Brooklyn Film Festival"
                  className="festival-client-logo-dark max-h-[2.85rem] max-w-[2.85rem] object-contain"
                />
              </span>
            </p>
            <p className="flex items-center gap-kit-10">
              <a
                href="https://www.artsgowanus.org/"
                target="_blank"
                rel="noreferrer"
                className="inline-block w-[13rem] whitespace-nowrap underline"
              >
                Gowanus Open Studios
              </a>
              <span className={festivalLogoSlotClassName}>
                <img
                  src={artsGowanusLogo}
                  alt="Arts Gowanus"
                  className="festival-client-logo-light max-h-[2.85rem] max-w-[2.85rem] object-contain"
                />
                <img
                  src={artsGowanusLogoDark}
                  alt="Arts Gowanus"
                  className="festival-client-logo-dark max-h-[2.85rem] max-w-[2.85rem] object-contain"
                />
              </span>
            </p>
            <p className="flex items-center gap-kit-10">
              <a
                href="https://www.redhookopenstudios.com/"
                target="_blank"
                rel="noreferrer"
                className="inline-block w-[13rem] whitespace-nowrap underline"
              >
                Red Hook Open Studios
              </a>
              <span className={festivalLogoSlotClassName}>
                <img
                  src={redHookOpenStudiosLogo}
                  alt="Red Hook Open Studios"
                  className="festival-client-logo-light max-h-[2.85rem] max-w-[2.85rem] object-contain"
                />
                <img
                  src={redHookOpenStudiosLogoDark}
                  alt="Red Hook Open Studios"
                  className="festival-client-logo-dark max-h-[2.85rem] max-w-[2.85rem] object-contain"
                />
              </span>
            </p>
            <p className="flex items-center gap-kit-10">
              <a
                href="https://www.winterjazzfest.com/"
                target="_blank"
                rel="noreferrer"
                className="inline-block w-[13rem] whitespace-nowrap underline"
              >
                Winter Jazzfest
              </a>
              <span className={festivalLogoSlotClassName}>
                <img
                  src={winterJazzfestLogo}
                  alt="Winter Jazzfest"
                  className="max-h-[2.85rem] max-w-[2.85rem] object-contain"
                />
              </span>
            </p>
          </div>
        </div>
        <p className="text-kit-sm font-['Primary-Bold'] leading-[1.45]">
          if interested, please contact us at{" "}
          <a
            href="mailto:info@inyc.us"
            className="font-['Primary-Bold'] underline"
          >
            info@inyc.us
          </a>
        </p>
        <p className="mt-kit-20 text-kit-base leading-[1.45]">
          mapping your festival offers a seamless way for your fanbase to easily
          explore, navigate, share and plan their experience. more engaging, no
          waste and less expensive.
        </p>
        <div className="mt-kit-20 space-y-[1.25rem] text-kit-base leading-[1.45]">
          <p>
            music festival? acts once unfamiliar now have a sound via embedded
            links, see the venue they are playing at, learn about the group.
            share with friends. buy a ticket.
          </p>
          <p>
            film festival? instantly watch the trailers of films being screened
            to plan the must sees of the event. learn about the director and
            cast. know the location. send to friends and buy tickets, all in one
            place.
          </p>
          <p>
            custom filter buttons allow your attendees to remove everything on
            in—yc except what's a part of the festival.
          </p>
          <p>
            it also facilitates supporting other local art events close by that
            are festival adjacent.
          </p>
          <div>
            <p className="font-['Primary-Bold']">from Winter Jazzfest:</p>
            <img
              src={inycIphoneMockupLight}
              alt="Winter Jazzfest in-yc iPhone example"
              className="festival-client-logo-light mx-auto mt-kit-10 block w-full max-w-[22rem] rounded-kit-lg"
            />
            <img
              src={inycIphoneMockupDark}
              alt="Winter Jazzfest in-yc iPhone example"
              className="festival-client-logo-dark mx-auto mt-kit-10 block w-full max-w-[22rem] rounded-kit-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Festivals;
